import { render, staticRenderFns } from "./sdraft.vue?vue&type=template&id=95f15b02&scoped=true&"
import script from "./sdraft.vue?vue&type=script&lang=js&"
export * from "./sdraft.vue?vue&type=script&lang=js&"
import style0 from "./sdraft.vue?vue&type=style&index=0&id=95f15b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f15b02",
  null
  
)

export default component.exports